import { buildGlobalAction, buildInlineComputedView } from "./../builder.js";
class ZendeskNamespace {
  constructor(clientOrParent) {
    this.clientOrParent = clientOrParent;
    /** Executes the disconnect global action. */
    this.disconnect = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "disconnect",
      operationName: "disconnect",
      operationReturnType: "ZendeskDisconnect",
      namespace: "zendesk",
      variables: { customerId: { required: false, type: "String" } }
    });
    /** Executes an inline computed view. */
    this.view = buildInlineComputedView(this, {
      type: "computedView",
      operationName: "gellyView",
      functionName: "view",
      gqlFieldName: "gellyView",
      namespace: "zendesk",
      variables: {
        query: { type: "String", required: true },
        args: { type: "JSONObject" }
      }
    });
    this.connection = this.clientOrParent.connection;
  }
}
export {
  ZendeskNamespace
};
//# sourceMappingURL=zendesk.js.map
